import React from "react";
import Footer from "./Footer";

function AboutUs() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      
      {/* ===== CONTENT ===== */}
      <div style={{ flex: 1, padding: "40px", maxWidth: 900, margin: "auto" }}>
        <h1 style={{ textAlign: "center", marginBottom: 20 }}>About Us</h1>

        <p style={{ fontSize: 16, lineHeight: 1.7 }}>
          Welcome to <strong>KingShop</strong> — your trusted online shopping
          destination. We aim to provide high-quality products at the best prices
          with a smooth and secure shopping experience.
        </p>

        <h3 style={{ marginTop: 30 }}>🛍️ What We Offer</h3>
        <ul style={{ lineHeight: 1.8 }}>
          <li>Wide range of quality products</li>
          <li>Affordable pricing with exciting discounts</li>
          <li>Secure checkout and reliable delivery</li>
          <li>Easy returns and customer support</li>
        </ul>

        <h3 style={{ marginTop: 30 }}>🎯 Our Mission</h3>
        <p style={{ lineHeight: 1.7 }}>
          Our mission is to make online shopping simple, affordable, and reliable
          for everyone. Customer satisfaction is our top priority.
        </p>

        <h3 style={{ marginTop: 30 }}>🤝 Why Choose KingShop?</h3>
        <ul style={{ lineHeight: 1.8 }}>
          <li>100% genuine products</li>
          <li>Fast & secure payments</li>
          <li>Trusted delivery partners</li>
          <li>Dedicated customer support</li>
        </ul>

        <h3 style={{ marginTop: 30 }}>📞 Contact Us</h3>
        <p>
          Email: <strong>kingshoppy.as@gmail.com</strong> <br />
          Phone: <strong>+91-8966825777</strong>
        </p>
      </div>

      {/* ===== FOOTER ===== */}
      <Footer />
    </div>
  );
}

export default AboutUs;
